<template>
  <div>
    <v-dialog v-model="final_lien_release_report" max-width="1200" persistent>
      <v-card :loading="loading">
        <v-card-text
          class=""
        >
          <v-row dense class="ml-2 mt-3 report-header2 custom-font-for-print">
            <v-col cols="12" style="font-size: 18px;" class="text-center mt-2">
              <b>WAIVER AND RELEASE OF LIEN FINAL PAYMENT</b>
              <v-divider class="mt-3 mb-5"></v-divider>
            </v-col>
            <v-col cols="12" class="d-flex">
              <span v-html="getReportText(3,1)"></span>
              <span class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(3,1)"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" style="margin-top: 16px;">Lienor's Name : {{company_details.name}}</v-col>
            <v-col cols="12" style="margin-top: 16px;">Address : {{company_details.shipping_address_line_1}}, {{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}</v-col>

            <v-col cols="2" style="margin-top: 20px;"></v-col>
            <v-col cols="2">
              <v-divider style="margin-top: 45px;"></v-divider>
            </v-col>
            <v-col cols="8" style="margin-top: 20px;"></v-col>

            <v-col cols="2">By :</v-col>
            <v-col cols="10"><b>President</b></v-col>
            <v-col cols="2">Printed Name :</v-col>
            <v-col cols="10"><b>{{company_details.contact_person}}</b></v-col>
            <v-col cols="12" class="d-flex" style="margin-top: 20px;">
              <span v-html="getReportText(3,2)"></span>
              <span class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(3,2)"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" class="d-flex" style="margin-top: 20px;">
              <i><span v-html="getReportText(3,3)"></span></i>
              <span class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(3,3)"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
           <v-btn
            :loading="loading" @click="generateReport('whole_page',true); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading" @click="generateReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe
                :src="preview_page_link"
                frameborder="0"
                style="width:100%;height:800px"
              ></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>  
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="report_text_dialog" max-width="900" persistent>
      <v-card :loading="report_text_loading">
        <v-card-title class="headline">Update Text</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <vue-editor v-model="report_text_data.text" :editor-toolbar="customToolbar"/>
            </v-col>
            <v-col cols="12">
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '1' && report_text_data.section  == '14'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{amount}</v-col>
                <v-col cols="12">{amount_in_word}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '2' && report_text_data.section  == '1'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{amount_in_word}</v-col>
                <v-col cols="12">{project_details}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '3' && report_text_data.section  == '1'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{balance}</v-col>
                <v-col cols="12">{project_name}</v-col>
                <v-col cols="12">{customer_address}</v-col>
              </v-row>
                <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '3' && report_text_data.section  == '2'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{current_year}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="report_text_dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('no')"
          >Update for this project</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('yes')"
          >Update Template</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SendMailDialog :email_id="email_ids" :email_dialog="email_dialog" @closeDialog="closeSendMailDialog" @sendMail="sendMail" />
    <Signatura :customer_sign="customer_sign_blob" :active_page="active_page" @updateValue="updateParent" @clearValue="clearParent" :project_details="project_details" :signature_dialog="signature_dialog" />
  </div>
</template>
 <script>
 import { VueEditor } from "vue2-editor";
 import { getCompanyDetails, getAmountInWord } from "../../plugins/helper";
 import Signatura from "../projects/Signatura";
 import SendMailDialog from "../projects/SendMailDialog";
 import axios from "../../plugins/axios";
 import { mapMutations } from "vuex";
 export default {
   data() {
     return {
       customToolbar: [
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike"], // toggled buttons
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          //["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ color: [] }, { background: [] }],
          ["link", "image", "video"],
          //["clean"],
          // This is what I have added
          [{ 'size': ['small', false, 'large'] }],
      ],
      report_text_dialog: false,
      report_text_loading: false,
      report_text_data: {},
      report_texts: [],
      project_report_texts: [],
      preview_pdf_loading: '',
      total_page: '',
      active_page: 0,
      user_sign_blob: [],
      customer_sign_blob: '',
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      company_details: getCompanyDetails(),
      preview_pdf_dialog: false,
      preview_page_link: '',
      total_amt: '',
      project_data_flag: '',
      invoice_list:[{
        amount: '0',
        invoice_number:'0',
        generated_inv_id:'0'
      }],
      invoice_no:'0',
     }
   },
   props: ['final_lien_release_report','project_details', 'report_header_name'],
   watch: {
     final_lien_release_report: function(value) {
      if (value) {
       
        if (this.project_details.project_work[0].project_work == 'remodeling') {
          this.project_data_flag = 2
        } else if(this.project_details.project_work[0].project_work == 'new_construction') {
          this.project_data_flag = 1
        } else if(this.project_details.project_work[0].project_work == 'project_management') {
          this.project_data_flag = 4
        }
        this.preview_page_link = '';
        this.active_page = 0;
        this.user_sign_blob = []; 
        this.customer_sign_blob = '';
        this.getInvoiceList();
        this.getTotalPage();
        this.getReportTexts();
        // this.getAllInvoiceData();

      }
    }
   },
   computed: {
     amount_in_word() {
      return getAmountInWord(this.total_amt)
    },
     user_name() {
       return localStorage.getItem('user_name');
     }
   },
   components: {
      Signatura,
      SendMailDialog,
      VueEditor
    },
   methods: {
     ...mapMutations("utils", ["setAlert"]),
      updateReportText(update_for_all_project) {
        this.report_text_data.project_id = this.project_details.project_id;
        this.report_text_data.update_for_all_project = update_for_all_project;
        this.report_text_loading = true;
        let _self = this;
        axios
          .post("update_project_report_text", this.report_text_data)
          .then(function() {
            _self.report_text_dialog = false;
            _self.getReportTexts();
            _self.report_text_loading = false;
          })
          .catch(function() {
            _self.report_text_loading = false;
          });
      },
      sendMail(variable) {
        this.email_id_arr = variable
        this.sendSalesInvoiceReport();
      },
      closeSendMailDialog() {
        this.email_dialog = false; 
        this.preview_pdf_dialog = false; 
        this.user_sign_blob = []; 
        this.customer_sign_blob = ''; 
        this.active_page = 0;
      },
      updateParent(variable) {
        if(variable.user_sign_blob) {
          this.user_sign_blob.push({page: this.active_page, sign_blob: variable.user_sign_blob})
        }
        if(variable.customer_sign_blob && this.active_page == 1) {
          this.customer_sign_blob = variable.customer_sign_blob
        }
        this.signature_dialog = false
        if(this.is_send_report) {
          if(this.total_page == this.active_page) {
            this.email_dialog = true; 
            this.email_ids = this.project_details.customer.email+'@'+this.project_details.customer.email_domain.domain;
          } else {
            this.generateReport(false);
          }
        } else {
          if(this.total_page == this.active_page) {
            this.generateReport(true);
          } else {
            this.generateReport(false);
          }
        }
      },
      clearParent(variable) {
        console.log(variable)
        this.signature_dialog = false
      },
      closePopup() {
        this.$emit('updateValue');
      },
      getTotalPage() {
        let company_data = localStorage.getItem('company_data')
        company_data = JSON.parse(company_data)
        var formData = new FormData();
        formData.append('project_id',this.project_details.project_id)
        formData.append('user_name',localStorage.getItem('user_id'))
        formData.append('company_id',company_data.company_id)
        formData.append('generate_pdf_flag','get_total')
        formData.append('project_data_flag',this.project_data_flag)
        formData.append('report_name','final_lien_release')
        formData.append('report_header_name',this.report_header_name)
        this.loading = true;
        axios
        .post("generate_report_pdf",formData,{
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          if(response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });  
      },
      generateReport(is_past_page,direct_print=false) {
        this.preview_pdf_loading = true;
        this.active_page++;
        let company_data = localStorage.getItem('company_data')
        company_data = JSON.parse(company_data)
        // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
        var formData = new FormData();

        if(is_past_page) {
          if(this.user_sign_blob) {
            for (let key in this.user_sign_blob) {
              formData.append(`user_sign_blob[${this.user_sign_blob[key].page}]`, this.user_sign_blob[key].sign_blob);
            }
          }
          if(this.customer_sign_blob) {
            formData.append(`customer_sign_blob`, this.customer_sign_blob);
          }
          formData.append('generate_pdf_flag','whole_page')
        } else {
          formData.append('generate_pdf_flag','single_page')
        }
        formData.append('flag','save')
        formData.append('project_id',this.project_details.project_id)
        formData.append('user_name',localStorage.getItem('user_id'))
        formData.append('company_id',company_data.company_id)
        formData.append('total_page',this.total_page)
        formData.append('active_page',this.active_page)
        formData.append('project_data_flag',this.project_data_flag)
        formData.append('report_name','final_lien_release')
        formData.append('report_header_name',this.report_header_name)
        formData.append('direct_print',direct_print)
        axios
        .post("generate_report_pdf",formData,{
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          if(is_past_page) {
            if(response.data.status) {
              if(direct_print){
                var File_url=response.data.file_url;
                window.open(File_url, 'Download');
              }else{
              this.setAlert({
                show: true,
                variant: "primary",
                message: response.data.message,
                dismissCountDown: 0
              });
              this.closePopup();
              }
              this.preview_pdf_dialog = false;
            }
          } else {
            this.preview_page_link = response.data.preview_page_link;
          }
          this.preview_pdf_loading = false
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false
        });           
      },
      sendSalesInvoiceReport() {
        let company_data = localStorage.getItem('company_data')
        company_data = JSON.parse(company_data)
        let data = {
          flag: 'mail',
          project_id: this.project_details.project_id,
          user_name: localStorage.getItem('user_id'),
          company_id: company_data.company_id,
          active_page: this.active_page,
          total_page: this.total_page,
          email_id_arr: this.email_id_arr,
          email_ids: this.email_ids,
          generate_pdf_flag: 'whole_page',
          project_data_flag: this.project_data_flag,
          report_name: 'final_lien_release'
        }
        if(this.user_sign_blob) {
          data.user_sign_blob = this.user_sign_blob
        }
        if(this.customer_sign_blob) {
          data.customer_sign_blob = this.customer_sign_blob
        }

        this.send_pdf_loading = true;
        axios
        .post("generate_report_pdf",data)
        .then(response => {
          this.email_ids_error = null;
          if(response.data.status) {
            this.email_dialog = false
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
              this.email_ids_error = response.data.errors['email_ids'];
          }
          this.send_pdf_loading = false
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false
        });        
      },
      getReportDetails() {
        let _self = this;
        this.loading = true;
        axios
        .get("get_item_group?project_id="+this.project_details.project_id+"&project_data_flag="+this.project_data_flag)
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data
          _self.total_amt = response_data.total_amt
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
      },
      openReportTextDialog(report, section) {
        this.report_text_data.text = this.getReportText(report, section, true);
        this.report_text_data.report = report;
        this.report_text_data.section = section;
        this.report_text_dialog = true;
      },
      getReportText(report, section, is_edit_mode) {
        let report_text = "";
        this.project_report_texts.filter(item => {
          if (item.report == report && item.section == section) {
            report_text = item.text;
          }
        });
        if (!report_text) {
          this.report_texts.filter(item => {
            if (item.report == report && item.section == section) {
              report_text = item.text;
            }
          });
        }
        
        if (report == "1" && section == "14" && !is_edit_mode) {
          let totalScheduleValue = "$" + this.total_amt;
          let amountInWord = "US$ " + this.amount_in_word;
          report_text = report_text.replace("{amount}", totalScheduleValue);
          report_text = report_text.replace("{amount_in_word}", amountInWord);
        }
        if (report == "2" && section == "1" && !is_edit_mode) {
          let amountInWord = "US$ " + this.amount_in_word;
          report_text = report_text.replace("{amount_in_word}", amountInWord);
          let address = '<b>'+this.project_details.p_address_1+''+(this.project_details.p_address_2 ? ', '+this.project_details.p_address_2 : '')+''+(this.project_details.city? ', '+ this.project_details.city.city_name:'')+''+(this.project_details.state?', '+this.project_details.state.state_name:'')+''+(this.project_details.p_zip ? '-'+this.project_details.p_zip: '')+'</b>'
          report_text = report_text.replace("{project_details}", address);
        }
        if (report == "3" && section == "1" && !is_edit_mode) {
          let balance = "$" + this.total_amt;
          report_text = report_text.replace("{balance}", balance);
          report_text = report_text.replace(
            "{project_name}",
            this.project_details.p_name
          );
          let address_line_1=this.project_details.customer && this.project_details.customer.address_line_1 ? this.project_details.customer.address_line_1 :'';
          let address_line_2=this.project_details.customer && this.project_details.customer.address_line_2 ? ', ' +this.project_details.customer.address_line_2 :'';
          let city=this.project_details.customer && this.project_details.customer.city_details  ? this.project_details.customer.city_details.city_name :'';
          let state=this.project_details.customer && this.project_details.customer.state_details  ? this.project_details.customer.state_details.state_name :'';
          let zip=this.project_details.customer && this.project_details.customer.zip  ?this.project_details.customer.zip :'';
          let address=address_line_1+''+address_line_2+', '+city+', '+state+', '+zip;
          report_text = report_text.replace( "{customer_address}",(this.project_details && this.project_details.customer) ?  address : '' );
        }
        if (report == "3" && section == "2" && !is_edit_mode) {
          let current_year=new Date().getFullYear();
          report_text = report_text.replace("{current_year}", current_year);
        }
        return report_text;
      },
      getReportTexts() {
        let _self = this;
        this.loading = true;
        axios
          .get("get_report_texts?project_id="+this.project_details.project_id)
          .then(function(res) {
            _self.project_report_texts = res.data.project_report_texts
            _self.report_texts = res.data.data;
            _self.loading = false;
          })
          .then(function() {
            _self.loading = false;
          });
      },
      getInvoiceList(){
        let _self = this;
        this.loading = true;
        axios
        .get("get_project_invoice_list?project_id="+this.project_details.project_id)
        .then(response => {
          let response_data = response.data;
          _self.invoice_no=response.data.last_invoice;
          response_data.invoice_list.map(function (item) {
               _self.invoice_list.unshift(item);
          });
          this.getAllInvoiceData();
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
      },
       getAllInvoiceData(){
        let _self = this;
        let invoice_no=_self.invoice_no;
        _self.loading = true;
        axios
        .get("get_all_invoice_detail?project_id="+this.project_details.project_id+"&project_data_flag="+this.project_data_flag+"&generate_invoice_id="+invoice_no)
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data
          _self.total_amt = response_data.finallien_sum_of
          _self.application_date=response_data.application_date
          _self.project_name=response_data.project_name
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
      },
    },
    created: function() {
    },
    mounted: function () {
      // this.$refs.userSignaturePad.openSignaturePad();
      // this.$refs.customerSignaturePad.openSignaturePad();
    }
 }
 </script>
 <style scoped>
.right-border-grey > td {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.right-border-white > td {
  border-right: thin solid white;
}
ul li {
  list-style-type: none;
  &:before {
    content: "• ";
    margin-left: -1em;
  }
}
</style>